function ChatMessageItemReply({
  adminMessage,
  name,
  message,
  goToReplyMessage,
  lang,
  messageTypeFunction,
  videoFunctions,
  checkExists,
  videoExists,
}) {
  const {
    imageLoaded,
    onImageLoaded,
    onImageError,
    reloadSticker,
    displayText,
    viewImage,
    downloadFile,
    downloadIcon,
    fileIcon,
    urlError,
  } = messageTypeFunction;

  function fileSizeFilter(size) {
    if (isNaN(size)) size = 0;

    if (size < 1024) return `${size} Bytes`;

    size /= 1024;

    if (size < 1024) return `${size.toFixed(2)} KB`;

    size /= 1024;

    if (size < 1024) return `${size.toFixed(2)} MB`;

    size /= 1024;

    if (size < 1024) return `${size.toFixed(2)} GB`;

    size /= 1024;

    return `${size.toFixed(2)} TB`;
  }

  const sourceMsg = message.sender == message.pid;
  const repliedOwnedMessage =
    (message.reply_to?.sender || message.reply_to?.payload?.sender) ==
    message.sender;

  return (
    <div>
      {message.reply_to?.sender || message.reply_to?.payload?.sender ? (
        <div
          style={{
            paddingBottom: "5px",
            marginLeft: "6px",
            fontSize: "12px",
            color: "#8392AF",
            textAlign: sourceMsg ? "end" : "start",
          }}
        >
          <i class="icon icon-fluent_arrow-reply" style={{ margin: "unset" }}></i>
          <span>
            {sourceMsg
              ? repliedOwnedMessage
                ? lang.__replied_to_yourself
                : `${lang.__replied} ${name}`
              : repliedOwnedMessage
              ? lang.__replied_themselves
              : lang.__replied_to_you}
          </span>
        </div>
      ) : null}
      <div
        className={`message-text ${
          message.type === "video" ? "video-chat" : ""
        }`}
        style={{
          minWidth: message.reply_to.type !== "text" ? "160px" : "unset",
        }}
      >
        <div
          onClick={() =>
              ["file", "image", "sticker", "text", "flex", "video", "share_post"].includes(
              message.reply_to.type
            ) &&
            goToReplyMessage(
              message.time,
              message.reply_to.time,
              message.reply_to.type,
              message.reply_to.imageIndex
            )
          }
          style={{
            paddingBottom: "10px",
            borderBottom: "1px solid #CEDAEE",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: [
              "file",
              "image",
              "sticker",
              "text",
              "flex",
              "video",
            ].includes(message.reply_to.type)
              ? "pointer"
              : "default",
          }}
        >
          {message.reply_to.is_deleted ? (
            <span
              className="reply-to sp-text-help"
              style={{ color: sourceMsg && "#fff" }}
            >
              {`${name} ${lang.__unsent_message_no_name}`}
            </span>
          ) : (
            <>
              {message.reply_to.type === "text" && (
                <span
                  className="reply-to sp-text-help"
                  style={{ color: sourceMsg && "#fff" }}
                >
                  {message.reply_to.is_deleted
                    ? `${name} ${lang.__unsent_message_no_name}`
                    : message.reply_to.text}
                </span>
              )}
              {message.reply_to.type !== "text" && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    maxWidth: "80%",
                    marginRight: "10px",
                  }}
                >
                  <span
                    className="reply-to sp-text-help -ellipsis"
                    style={{
                      alignContent: "center",
                      paddingRight: "10px",
                      maxWidth:
                        message.reply_to.type === "file" ? "200px" : "unset",
                      color: sourceMsg && "#fff",
                    }}
                  >
                    {message.reply_to.type === "image"
                      ? lang.__photo
                      : message.reply_to.type === "video"
                      ? lang.__send_A_Video
                      : message.reply_to.type === "sticker"
                      ? lang.__send_A_Sticker
                      : message.reply_to.type === "file"
                      ? `${lang.__file}: ${message.reply_to?.metadata?.name}`
                      : message.reply_to.type === "flex"
                      ? `${lang.__flex_message}: ${message.reply_to.altText}`
                      : message.reply_to.type === "share_post"
                      ? lang.__share_A_Post
                      : lang.__message_unavailable}
                  </span>
                  {message.reply_to.type === "file" && (
                    <p
                      className="sp-text-help"
                      style={{ fontSize: "12px", color: sourceMsg && "#fff" }}
                    >
                      {message.reply_to.url_error ? (
                        <span>{lang.__file_expire}</span>
                      ) : (
                        <>
                          <span>{lang.__send_a_file_size}</span>{" "}
                          <span>
                            {fileSizeFilter(message.reply_to?.metadata?.size)}
                          </span>
                        </>
                      )}
                    </p>
                  )}
                </div>
              )}
              {message.reply_to.type === "file" &&
                (!message.reply_to.url_error ? (
                  <img
                    style={{
                      width: "28px",
                      maxHeight: "60px",
                      opacity: sourceMsg ? "1" : "0.2",
                    }}
                    src={`/public/img/${
                      message.reply_to?.metadata?.icon || "icon-doc-text"
                    }${sourceMsg ? "-w.png" : ".png"}`}
                    alt="file icon"
                  />
                ) : (
                  <img
                    style={{ width: "28px", maxHeight: "60px" }}
                    src={`/public/img/expire_file${sourceMsg ? "-w" : ""}.png`}
                    alt="file icon"
                  />
                ))}
              {message.reply_to.type === "video" &&
                !message.reply_to.url_error && (
                  <img
                    style={
                      message.reply_to.thumbnail_url
                        ? {
                            width: "44px",
                            height: "44px",
                            borderRadius: "8px",
                            objectFit: "cover",
                          }
                        : { width: "28px", maxHeight: "60px" }
                    }
                    src={
                      message.reply_to.thumbnail_url ||
                      `/public/img/videocam${sourceMsg ? "-w" : ""}.png`
                    }
                    alt="video icon"
                    onError={(e) => {
                      e.target.src = `/public/img/videocam${
                        sourceMsg ? "-w" : ""
                      }.png`;
                    }}
                  />
                )}
              {message.reply_to.type === "video" &&
                message.reply_to.url_error && (
                  <img
                    style={{ width: "28px", maxHeight: "60px" }}
                    src={`/public/img/expire_file${
                      sourceMsg ? "-w.png" : ".png"
                    }`}
                    alt="video icon"
                  />
                )}
              {message.reply_to.type === "image" &&
                !(
                  message.reply_to.img_urls ||
                  message.reply_to.img_url ||
                  message.reply_to.img_url_full ||
                  message.reply_to.image ||
                  message.reply_to.image_url
                ) &&
                !message.reply_to.url_error && (
                  <span
                    className="message-image image_reply loading"
                    style={{ width: "unset", height: "unset" }}
                  >
                    <div className="sp-placeholder">
                      <div className="sp-text-help">
                        <i
                          className="icon icon-circle-notch animate-spin"
                          style={{ margin: "unset" }}
                        ></i>
                      </div>
                    </div>
                  </span>
                )}
              {message.reply_to.type === "image" &&
                !message.reply_to.url_error &&
                (message.reply_to?.img_urls ||
                  message.reply_to.img_url ||
                  message.reply_to.img_url_full ||
                  message.reply_to.image ||
                  message.reply_to.image_url) && (
                  <img
                    id="imagesave"
                    className="image_reply"
                    src={
                      message.reply_to.amount_image > 1
                        ? message?.reply_to?.img_urls
                          ? message?.reply_to?.img_urls[
                              message?.reply_to?.imageIndex || 0
                            ]
                          : Array.isArray(message.reply_to.image_url)
                          ? message.reply_to.image_url[
                              message.reply_to.imageIndex || 0
                            ]
                          : ""
                        : message.reply_to.img_url ||
                          message.reply_to.img_url_full ||
                          message.reply_to.image ||
                          message.reply_to.image_url
                    }
                    alt="reply image"
                  />
                )}
              {message.reply_to.type === "image" &&
                message.reply_to.url_error && (
                  <span
                    className="msg-image image_reply loading"
                    style={{
                      width: "unset",
                      height: "unset",
                      backgroundColor: "#E9EDF3",
                    }}
                  >
                    <div className="sp-placeholder">
                      <div className="sp-text-help">
                        <i
                          className="icon icon-no-pic"
                          style={{ margin: "unset", color: "#8E9AAD" }}
                        ></i>
                      </div>
                    </div>
                  </span>
                )}
              {message.reply_to.type === "sticker" &&
                !message.reply_to.url_error && (
                  <img
                    id="imagesave"
                    className="image_reply"
                    style={{ objectFit: "contain" }}
                    src={
                      message?.reply_to?.line_sticker_id
                        ? `https://stickershop.line-scdn.net/stickershop/v1/sticker/${message?.reply_to?.line_sticker_id}/iPhone/sticker.png`
                        : message.reply_to.facebook_sticker_url
                    }
                    alt="sticker"
                    onError={() => {
                      message.reply_to.url_error = true;
                    }}
                  />
                )}
              {message.reply_to.type === "sticker" &&
                message.reply_to.url_error && (
                  <span
                    className="message-image image_reply loading"
                    style={{
                      width: "unset",
                      height: "unset",
                      backgroundColor: "#E9EDF3",
                    }}
                  >
                    <div className="sp-placeholder">
                      <div className="sp-text-help">
                        <i
                          className="icon icon-delete-sticker"
                          style={{ margin: "unset", color: "#8E9AAD" }}
                        ></i>
                      </div>
                    </div>
                  </span>
                )}
            </>
          )}
        </div>
        {message.type === "sticker" && imageLoaded && (
          <div
            className="message-image"
            data-reply-anchor="true"
            style={{ paddingTop: "10px" }}
          >
            <a
              href={message.img_url_full}
              target="__blank"
              rel="noopener noreferrer"
            >
              <img
                className="image sticker"
                style={{ maxWidth: "200px" }}
                src={message.sticker_url}
                onClick={reloadSticker}
                onLoad={onImageLoaded}
                onError={onImageError}
                alt="sticker"
              />
            </a>
          </div>
        )}
        {(message.type === "sticker" || message.type === "image") &&
          !(
            message?.image?.length > 0 ||
            message?.img_url?.length > 0 ||
            message?.img_url_full?.length > 0
          ) &&
          !imageLoaded &&
          !urlError && (
            <div
              className="message-image loading"
              data-reply-anchor="true"
              style={{
                marginTop: "10px",
                marginLeft: "unset",
                maxWidth: "100%",
              }}
            >
              <div className="sp-placeholder">
                <div className="sp-text-help">
                  <i className="icon icon-circle-notch animate-spin"></i>{" "}
                  <span>{lang.__loading}</span>
                </div>
              </div>
            </div>
          )}
        {message.type === "image" && !urlError ? (
          message.amount_image > 1 ? (
            <div
              className="message-image-multiple"
              data-reply-anchor="true"
              style={{ paddingTop: "10px", margin: "unset" }}
            >
              {message.img_urls &&
                message.img_urls.map((item, index) => (
                  <div key={index} onClick={() => viewImage(index)}>
                    <img
                      className="message-image"
                      src={item}
                      alt={`thumbnail-${index}`}
                    />
                  </div>
                ))}
            </div>
          ) : (
            <div
              className="message-image"
              data-reply-anchor="true"
              style={{ paddingTop: "10px", margin: "unset", maxWidth: "100%" }}
            >
              {message?.image?.length > 0 ||
              message?.img_url?.length > 0 ||
              message?.img_url_full?.length > 0 ? (
                <img
                  className="image"
                  style={{ maxWidth: "100%" }}
                  src={
                    message?.image?.length > 0
                      ? message.image
                      : message?.img_url?.length > 0
                      ? message.img_url
                      : message?.img_url_full?.length > 0
                      ? message.img_url_full
                      : ""
                  }
                  onClick={() => viewImage()}
                  alt="thumbnail"
                />
              ) : (
                ""
              )}
            </div>
          )
        ) : null}
        {message.type === "text" && (
          <div
            data-reply-anchor="true"
            style={{ paddingTop: "10px" }}
            dangerouslySetInnerHTML={{ __html: displayText }}
          ></div>
        )}
        {message.type === "file" && (
          <div
            className="file-download"
            data-reply-anchor="true"
            style={{
              maxWidth: "100%",
              marginLeft: "unset",
              marginTop: "10px",
              borderRadius: "12px",
            }}
          >
            <div
              className="sp-placeholder"
              style={{
                display: message.state === "sending" ? "block" : "none",
              }}
            >
              <div className="sp-text-help">
                <i className="icon icon-circle-notch animate-spin"></i>
              </div>
            </div>
            <div
              className="file-info"
              style={{
                display:
                  message.state === "finish" || message.state === "error"
                    ? "flex"
                    : "none",
                color: urlError && "#8E9AAD",
              }}
            >
              {urlError ? (
                <img
                  class="file-info-img"
                  style={{
                    height: "40p",
                    width: "36px",
                    "margin-right": "12px",
                  }}
                  src={`../public/img/expire_file.png`}
                />
              ) : (
                <img
                  className="file-info-img"
                  src={`../public/img/${
                    message.type === "file" ? fileIcon : `videocam`
                  }.png`}
                  alt="file icon"
                />
              )}
              <div className="file-info-text">
                <p className="sp-text">{message.metadata.name}</p>
                <p className="sp-text-help">
                  {urlError ? (
                    <span>{lang.__file_expire}</span>
                  ) : (
                    <>
                      <span>{lang.__send_a_file_size}</span>{" "}
                      <span>{fileSizeFilter(message.metadata.size)}</span>
                    </>
                  )}
                </p>
              </div>
            </div>
            <div
              className="separator"
              style={{
                display: message.state === "finish" ? "flex" : "none",
              }}
            ></div>
            <div
              className="sp-btn -blue"
              onClick={() =>
                !urlError &&
                downloadFile(
                  message.type === "file" ? message.file_url : message.video_url
                )
              }
              style={{
                display: message.state === "finish" ? "flex" : "none",
                cursor: urlError && "not-allowed",
                backgroundColor: urlError && "#D1D6DF",
              }}
            >
              <img
                className="icon-download"
                src={downloadIcon}
                alt="download icon"
              />
              <span>{lang.__download}</span>
            </div>
          </div>
        )}
        {message.type === "video" && (
          <>
            {!checkExists && videoExists && (
              <div
                className="msg video-player-container"
                style={{ margin: "16px 8px" }}
                data-reply-anchor="true"
              >
                {!videoFunctions.videoPlayerStarted &&
                  !videoFunctions.videoLoadingInProgress && (
                    <div
                      className="video-thumbnail-wrapper"
                      onClick={() => videoFunctions.startVideoPlayer()}
                    >
                      {message.thumbnail_url && (
                        <img
                          className="video-thumbnail"
                          src={message.thumbnail_url}
                          alt="Video thumbnail"
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      )}
                      <div className="video-play-overlay">
                        <i className="icon icon-play"></i>
                      </div>
                    </div>
                  )}

                {!videoFunctions.videoPlayerStarted &&
                  videoFunctions.videoLoadingInProgress && (
                    <div
                      className="msg-video-loading"
                      style={{ margin: "unset" }}
                    >
                      <div className="video-loading-placeholder">
                        <div className="loading-content">
                          <i className="icon icon-circle-notch animate-spin"></i>
                          <div className="loading-text">
                            <span>{lang.__loading}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                {videoFunctions.videoPlayerStarted &&
                  !videoFunctions.videoLoadingInProgress && (
                    <ReactVideoPlayer
                      url={message.video_url}
                      controls={true}
                      width={"100%"}
                      height={"183px"}
                      playing={true}
                      lang={lang}
                    />
                  )}
              </div>
            )}
            {!checkExists && !videoExists && (
              <div
                className="msg-video-loading"
                data-reply-anchor="true"
                style={{
                  backgroundColor: "#E9EDF3",
                  marginTop: "10px",
                  maxWidth: "unset",
                  marginLeft: "unset",
                  marginRight: "unset",
                }}
              >
                <div className="sp-placeholder">
                  <div className="sp-text-help" style={{ color: "#8E9AAD" }}>
                    <i
                      className="icon-no-pic"
                      style={{ fontSize: "24px", marginBottom: "12px" }}
                    ></i>
                    <div style={{ fontSize: "12px" }}>
                      {lang.__video_expire}
                    </div>
                    <div style={{ fontSize: "12px" }}>
                      {lang.__image_expire_desc}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        {message.type === "image" && urlError && (
          <div
            className="message-image loading"
            style={{
              backgroundColor: "#E9EDF3",
              marginTop: "10px",
              maxWidth: "100%",
              marginLeft: "unset",
            }}
          >
            <div className="sp-placeholder">
              <div
                className="sp-text-help"
                style={{ color: sourceMsg ? "#fff" : "#8E9AAD" }}
              >
                <i
                  className="icon-no-pic"
                  style={{ fontSize: "24px", marginBottom: "12px" }}
                ></i>
                <div style={{ fontSize: "12px" }}>{lang.__image_expire}</div>
                <div style={{ fontSize: "12px" }}>
                  {lang.__image_expire_desc}
                </div>
              </div>
            </div>
          </div>
        )}
        {message.type === "sticker" && urlError && (
          <div
            className="message-image loading"
            style={{
              backgroundColor: "#E9EDF3",
              marginTop: "10px",
              maxWidth: "unset",
              marginLeft: "unset",
            }}
          >
            <div className="sp-placeholder">
              <div
                className="sp-text-help"
                style={{ color: sourceMsg ? "#fff" : "#8E9AAD" }}
              >
                <i
                  className="icon-delete-sticker"
                  style={{ fontSize: "24px", marginBottom: "12px" }}
                ></i>
                <div style={{ fontSize: "12px" }}>{lang.__sticker_expired}</div>
                <div style={{ fontSize: "12px" }}>
                  {lang.__sticker_expired_desc}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
